import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateOrdinalSuffix'
})
export class DateOrdinalSuffixPipe implements PipeTransform {

  transform(date: string, args?: any): any {

  		if(date != '' && date != null)
  		{
	  		var dateArray = date.split(' ');
	  		var value = Number(dateArray[0]);
	  		var ordinal;

		    var j = value % 10,
		        k = value % 100;
		    if (j == 1 && k != 11) 
		    {
		       ordinal = "st";
		    }
		    else if (j == 2 && k != 12) 
		    {
		        ordinal = "nd";
		    }
		    else if (j == 3 && k != 13) 
		    {
		        ordinal = "rd";
		    }
		    else
		    {
		    	ordinal = "th";
		    }
		    return dateArray[0]+'<sup>'+ordinal+'</sup> '+dateArray[1]+' '+dateArray[2];
		}
  }

}
